import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static values = { url: String }

  async open(event) {
    event.preventDefault()
    
    try {
      // Fetch modal content
      const response = await fetch(this.urlValue, {
        headers: { 
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      const html = await response.text()
      
      // Insert into DOM
      const container = document.getElementById('lease_breaks_modal_container')
      if (container) {
        container.innerHTML = html
        
        // Show modal using Bootstrap
        const modalElement = document.getElementById('leaseBreaksModal')
        if (modalElement) {
          const modal = new Modal(modalElement)
          modal.show()
          
          // Clean up when modal is hidden
          modalElement.addEventListener('hidden.bs.modal', () => {
            container.innerHTML = ''
          }, { once: true })
        }
      }
    } catch (error) {
      console.error('Error loading lease breaks modal:', error)
    }
  }
}
